import { db } from "../firebase";
import { doc, setDoc } from "firebase/firestore";
import { uploadMedia } from "./uploadMedia";

async function updateBartracks({ bartracks, orgId }) {
  try {
    if (bartracks && bartracks.length > 0) {
      for (const bartrack of bartracks) {
        let uploadedBartrackImageUrl = bartrack.imageUrl;
        if (bartrack.imageUrl && bartrack.imageUrl.startsWith("blob:")) {
          uploadedBartrackImageUrl = await uploadMedia(
            bartrack.imageUrl,
            `bartrack/${bartrack.bartrackId}`,
          );
        }

        await setDoc(
          doc(db, "Bartracks", bartrack.id),
          {
            name: bartrack.name,
            imageUrl: uploadedBartrackImageUrl,
            bartrackId: bartrack.bartrackId,
            orgId,
            pressureLimit: bartrack.pressureLimit ?? null,
          },
          { merge: true },
        );

        for (const line of bartrack?.lines) {
          let uploadedLineImageUrl = line.imageUrl;
          if (line.imageUrl && line.imageUrl.startsWith("blob:")) {
            uploadedLineImageUrl = await uploadMedia(
              line.imageUrl,
              `bartrack/${orgId}/lines/${line.bartrackId}`,
            );
          }

          await setDoc(
            doc(db, "Bartracks", bartrack.id, "Lines", line.id),
            {
              name: line.name,
              profitabilityIndex: line.profitabilityIndex ?? null,
              imageUrl: uploadedLineImageUrl,
              bartrackId: line.bartrackId,
            },
            { merge: true },
          );
        }
      }
    }
  } catch (error) {
    console.error("Erreur lors de la mise à jour du bartrack :", error);
  }
}

export default updateBartracks;
